import styled from '@emotion/styled';
import { getServiceName } from '@repo/utils';
import { t } from 'i18next';

import { StackedModalProps } from 'store/modalStackStore';

import Flex from 'components/util/Flex';

interface UnavailableChangeBubbleModalProps extends StackedModalProps {}

const UnavailableChangeBubbleModal = ({ closeModal }: UnavailableChangeBubbleModalProps) => {
  return (
    <SUnAvailableChangeBubbleModal>
      <SUnAvailableChangeBubbleHeader align="center" justify="center">
        <p className="title">{t('chat.rewards_bubble_conversion_verify_complete')}</p>
      </SUnAvailableChangeBubbleHeader>
      <Flex justify="center">
        <SButton onClick={closeModal} $isTingle={getServiceName() === 'tingle'}>
          {t('chat.popup_done')}
        </SButton>
      </Flex>
    </SUnAvailableChangeBubbleModal>
  );
};

const SUnAvailableChangeBubbleModal = styled.div`
  width: 100%;
  padding: 40px 36px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

const SUnAvailableChangeBubbleHeader = styled(Flex)`
  .title {
    ${({ theme }) => theme.font.body1_m};
    text-align: center;
  }
`;

// 팅글 리워드 CTA: yellow/black (임시, 디자인 제안 Figma 1072:58012). 버블챗은 기존 primary/white 유지
const SButton = styled.button<{ $isTingle?: boolean }>`
  padding: 12px 0;
  width: 260px;
  border-radius: 8px;
  background-color: ${({ theme, $isTingle }) => ($isTingle ? theme.color.brand.primary : theme.color.static.primary)};
  color: ${({ theme, $isTingle }) => ($isTingle ? '#000000' : theme.color.static.white)};
  ${({ theme }) => theme.font.body1_m};
`;

export default UnavailableChangeBubbleModal;
